import { render, staticRenderFns } from "./BackTest.vue?vue&type=template&id=65516326&scoped=true&"
import script from "./BackTest.vue?vue&type=script&lang=js&"
export * from "./BackTest.vue?vue&type=script&lang=js&"
import style0 from "./BackTest.vue?vue&type=style&index=0&id=65516326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65516326",
  null
  
)

export default component.exports